import { render, staticRenderFns } from "./SmartBonesClassic.vue?vue&type=template&id=309c03f5&scoped=true"
import script from "./SmartBonesClassic.vue?vue&type=script&lang=js"
export * from "./SmartBonesClassic.vue?vue&type=script&lang=js"
import style0 from "./SmartBonesClassic.vue?vue&type=style&index=0&id=309c03f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309c03f5",
  null
  
)

export default component.exports